import { LandlordTypeEnum } from '@modules/husleie-framework/src/types/Landlord.entity';
import { UserRoleEnum } from '@modules/husleie-framework/src/types/User.entity';
import type LandlordState from '@modules/store/landlord/types/LandlordState.entity';

export const state: LandlordState = {
  loading: false,
  loaded: false,
  apiError: false,
  isSudo: false,
  landlord: {
    type: LandlordTypeEnum.PRIVATE,
    id: null,
    user: {
      firstName: '',
      lastName: '',
      fullName: '',
      email: '',
      mobilePhone: {},
      role: UserRoleEnum.LANDLORD,
    },
    address: {
      street: '',
      additionalAddress: '',
      postalCode: '',
      postalArea: '',
      country: {
        code: '',
      },
    },
    dateOfBirth: '',
  },
  rentalObjects: [],
  contracts: [],
  inspectionReports: [],
  tenancies: [],
  firstRentalObjectId: null,
  download: {
    token: undefined,
    session: {
      pdf: undefined,
    },
  },
};
